module.exports = __webpack_public_path__ + "img/menu24.75354c6e.png";